import React from "react"
import {FieldManagementPreviewProps} from "../../../../render/management-preview";
import FieldView from "../../../../render/view";


export default function FieldUrl_ManagementPreview(props: FieldManagementPreviewProps) {

    const model : any = {}
    model[props.field.fieldId] = "www.goodday.work"

    return <FieldView field={props.field} model={model} />
}